module.exports = __webpack_public_path__ + "static/ilustracao-backup-automatico-e30de88db3d5a6300fa3768b62dea20d.svg";